// extracted by mini-css-extract-plugin
module.exports = {"bodyText":"_2rfTyIH","h5Text":"P1EvmTU","h4Text":"_35yPXsr","h3Text":"_2lKHxSN","srOnly":"_16EJYPu","link":"_3VlBQrY _2rfTyIH","container":"_26dhdzA","list":"_3_HulsW"};